<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="申请状态" label-width="100">
        <el-select
          v-model="searchForm.applicationStatus"
          clearable
          placeholder="选择申请状态"
          @change="getCommissionApplication"
        >
          <el-option label="申请中" value="1"></el-option>
          <el-option label="已打款" value="2"></el-option>
          <el-option label="拒绝" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getCommissionApplication" type="success"
          >搜索</el-button
        >
      </el-form-item>

      <!-- <el-form-item>
                <el-button type="primary" @click="addUpdateInformationButton(null)" v-if="hasAuth('sys:information:save')">添加资讯</el-button>
            </el-form-item> -->
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="用户姓名"
        align="center"
        prop="customerName"
        width="200"
      >
      </el-table-column>
      <el-table-column
        label="用户银行卡id"
        align="center"
        prop="bankcardId"
        width="200"
      >
      </el-table-column>
      <el-table-column
        label="银行名称"
        align="center"
        prop="bankName"
        width="150"
      ></el-table-column>
      <el-table-column
        label="银行卡类型"
        align="center"
        prop="bankCode"
        width="150"
      ></el-table-column>
      <el-table-column
        label="银行卡卡号"
        align="center"
        prop="cardNumber"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label="交易金额"
        prop="deaMoney"
        width="260"
      ></el-table-column>
      <el-table-column
        prop="applicationStatus"
        align="center"
        label="申请状态"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            size="small"
            v-if="scope.row.applicationStatus === 1"
            type="warning"
            >申请中</el-tag
          >
          <el-tag
            size="small"
            v-else-if="scope.row.applicationStatus === 2"
            type="success"
            >已打款</el-tag
          >
          <el-tag
            size="small"
            v-else-if="scope.row.applicationStatus === 3"
            type="danger"
            >拒绝</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column
                    align="center"
                    label="操作人"
                    prop="nickName"
                    width="260"
            ></el-table-column> -->
      <el-table-column
        prop="createTime"
        align="center"
        width="200"
        label="创建时间"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        align="center"
        width="200"
        label="更新时间"
      >
      </el-table-column>
      <el-table-column
        prop="icon"
        align="center"
        width="360"
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            slot="reference"
            @click="updPaid(scope.row.id)"
            v-if="scope.row.applicationStatus === 1"
            >已打款</el-button
          >

          <el-button
            type="danger"
            plain
            slot="reference"
            @click="updRefuse(scope.row.id)"
            v-if="scope.row.applicationStatus === 1"
            >拒绝</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "CommissionApplication",
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      total: 0,
      size: 10,
      current: 1,
      addUpdateBillApplyShipmentsvisible: false,
      //assignRolesvisible: false,
    };
  },
  created() {
    this.getCommissionApplication();
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getCommissionApplication();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getCommissionApplication();
    },
    //获取发货列表
    getCommissionApplication() {
      // var startTime='';
      // var endTime='';
      // if(this.searchForm.createTime!=undefined){
      //     startTime=this.searchForm.createTime[0];
      //     endTime=this.searchForm.createTime[1];
      // }
      // this.searchForm.startTime=startTime
      // this.searchForm.endTime=endTime;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post(
          "/admin/commissionApplication/getCommissionApplicationList",
          this.searchForm,
        )
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.pages;
          this.total = res.data.total;
        });
    },
    //编辑已打款
    updPaid(id) {
      this.$confirm("确定已打款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/commissionApplication/updPaid", { id: id })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                this.getCommissionApplication();
              },
            });
          });
      });
    },
    //编辑拒绝
    updRefuse(id) {
      this.$confirm("确定拒绝吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/commissionApplication/updRefuse", { id: id })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                this.getCommissionApplication();
              },
            });
          });
      });
    },
    // addUpdateInformationButton(id){
    //     this.addUpdateBillApplyShipmentsvisible=true;
    //     this.$nextTick(()=>{
    //         this.$refs.addUpdateBillApplyShipments.init(id);
    //     })
    // },
    // //下架、上架资讯
    // updInformationStatus(id){
    //     this.$axios.post("/admin/information/updInformationStatus", {informationId:id}).then(res => {
    //         this.$message({
    //             showClose: true,
    //             message: res.msg,
    //             type: 'success',
    //             onClose: () => {
    //                 this.getInformations()
    //             }
    //         });
    //     });
    // },
    // //设置置顶资讯
    // updInformationTop(id){
    //     this.$axios.post("/admin/information/updInformationTop", {informationId:id}).then(res => {
    //         this.$message({
    //             showClose: true,
    //             message: res.msg,
    //             type: 'success',
    //             onClose: () => {
    //                 this.getInformations()
    //             }
    //         });
    //     });
    // },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
